import { z } from 'zod'
import { MeetingIdSchema } from '../meeting'
import { AccountIdSchema } from '../ids'
import { CalendarEventIdSchema } from '../calendar'
import { AreaIdSchema } from '../area'

export const NotificationSourceSchema = z.discriminatedUnion('kind', [
  z.object({ kind: z.literal('area'), id: AreaIdSchema }).strict(),
  z.object({ kind: z.literal('account'), id: AccountIdSchema }).strict(),
  z.object({ kind: z.literal('event'), id: CalendarEventIdSchema }).strict(),
  z.object({ kind: z.literal('meeting'), id: MeetingIdSchema }).strict(),
])
export type NotificationSource = z.infer<typeof NotificationSourceSchema>
